<template>
  <div class="relativity-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Δt' = Δt / √(1 - v²/c²)$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：两个参考系的对比 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="240" viewBox="0 0 400 240">
            <!-- 地面参考系 (S) -->
            <rect x="20" y="30" width="360" height="80" fill="rgba(255,255,255,0.05)" stroke="#888" />
            <text x="30" y="50" fill="#888" font-size="10">地面参考系 S</text>
            <circle cx="200" cy="70" r="10" fill="#2ed573" />
            <text x="180" y="95" fill="#2ed573" font-size="10">静止时钟</text>

            <!-- 飞船参考系 (S') -->
            <g :transform="`translate(${shipX}, 130)`">
               <rect x="0" y="0" width="120" height="70" rx="10" fill="rgba(0,210,255,0.1)" stroke="#00d2ff" stroke-width="2" />
               <circle cx="60" cy="35" r="8" fill="#ff4757" />
               <text x="35" y="60" fill="#00d2ff" font-size="9">运动时钟 (v)</text>
            </g>

            <!-- 光脉冲 S' -->
            <circle v-if="v > 0" :cx="shipX + 60" :cy="130 + 35 - t*30" r="3" fill="#ffd700" />
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>飞行速度 v/c</label>
               <span class="val">{{ (v/100).toFixed(2) }}</span>
            </div>
            <div class="stat">
               <label>时间膨胀因子 γ</label>
               <span class="val">{{ gamma.toFixed(3) }}</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <label>调节飞船速度 (趋近光速): {{ (v/100).toFixed(2) }}c</label>
               <el-slider v-model="v" :min="0" :max="99" size="mini"></el-slider>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>物理详解：</strong>爱因斯坦指出，光速在所有惯性系中相同。当物体以高速（接近光速）运动时，从地面观察，运动物体的<strong>时间会变慢</strong>（时间膨胀），且<strong>长度会缩短</strong>（长度收缩）。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RelativityViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      v: 60, // percentage of c
      shipX: 50,
      t: 0
    }
  },
  computed: {
    gamma() {
       const beta = this.v / 100;
       return 1 / Math.sqrt(1 - beta * beta);
    }
  },
  mounted() {
     this.timer = setInterval(() => {
        this.shipX = (this.shipX + this.v * 0.05) % 280;
        this.t = (this.t + 0.1) % 2;
     }, 30);
  },
  beforeDestroy() { clearInterval(this.timer); }
}
</script>

<style scoped lang="scss">
.relativity-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; display: flex; gap: 20px;
      .stat { background: rgba(0,0,0,0.6); padding: 5px 12px; border-radius: 6px; border-left: 3px solid #ff4757; label { display: block; font-size: 0.55rem; color: #888; } span { font-size: 0.9rem; color: #fff; font-family: monospace; } }
   }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
